'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analyticsData = require('./analytics-data.html');

var _analyticsData2 = _interopRequireDefault(_analyticsData);

var _analyticsData3 = require('./analytics-data.controller');

var _analyticsData4 = _interopRequireDefault(_analyticsData3);

require('./analytics-data.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsComponent = {
  restrict: 'E',
  bindings: {},
  template: _analyticsData2.default,
  controller: _analyticsData4.default,
  controllerAs: 'vm'
};

exports.default = analyticsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-data/analytics-data.component.js
 **/